import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'projects/packcert-web/src/environments/environment';

@Injectable()
export class CultivosService {

    constructor(private readonly _http: HttpClient){}

    // PAISES
    public getPaisesDenominacion(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Pais/GetAllConFiltro', filters);
    }

    // PROVINCIAS
    public getProvinciasPais(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Provincia/GetAllConFiltro', filters);
    }

    // MUNICIPIOS
    public getMunicipiosProvincia(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Municipio/GetAllConFiltro', filters);
    }

    // MARCAS
    public getMarcasByPaisDenominacion(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Marca/GetAllConFiltro', filters);
    }

    // MANTENIMIENTO CULTIVOS
    public getFincas(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Finca/GetAllConFiltro', filters);
    }

    public getFinca(fincaId) {
        return this._http.get<any>(environment.apiEndpoint + '/Finca/GetById/?fincaId=' + fincaId);
    }

    public createFinca(finca) {
        return this._http.post<any>(environment.apiEndpoint + '/Finca/InsertFinca/', finca);
    }

    public updateFinca(finca) {
        return this._http.put<any>(environment.apiEndpoint + '/Finca/', finca);
    }

    public deleteFinca(fincaId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Finca/?id=' + fincaId);
    }

    public getTotalesFincas(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Finca/GetTotalesConFiltro', filters);
    }

    // CULTIVOS FINCA Y DESIGNACIONES FINCA
    public getCultivosYDesignacionesFincaByFincaId(fincaId) {
        return this._http.get<any>(environment.apiEndpoint + '/Finca/GetFincaConCultivosYDesignacionesById/?fincaId=' + fincaId);
    }

    public getCultivosYDesignacionesFincaByFilters(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Finca/GetFincaConCultivosYDesignacionesByFiltro/', filters);
    }

    // CULTIVOS - FINCA
    public getCultivosByFincasADuplicar(fincaId) {
        return this._http.get<any>(environment.apiEndpoint + '/Cultivo/GetCultivosDisponiblesParaDuplicacion/?fincaId=' + fincaId);
    }

    public getCultivoFinca(cultivoId) {
        return this._http.get<any>(environment.apiEndpoint + '/Cultivo/GetById/?cultivoId=' + cultivoId);
    }

    public createCultivoFinca(cultivoFinca) {
        return this._http.post<any>(environment.apiEndpoint + '/Cultivo/', cultivoFinca);
    }

    public updateCultivoFinca(cultivoFinca) {
        return this._http.put<any>(environment.apiEndpoint + '/Cultivo/', cultivoFinca);
    }

    public deleteCultivoFinca(cultivoId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Cultivo/?id=' + cultivoId);
    }

    // CULTIVOS - MARCA
    public getCultivosMarcaByCultivoId(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CultivoMarca/GetAllConFiltro', filters);
    }

    public getCultivoMarca(cultivoId, marcaId) {
        return this._http.get<any>(environment.apiEndpoint + '/CultivoMarca/GetById/?cultivoId=' + cultivoId + '&marcaId=' + marcaId);
    }

    public createCultivoMarca(cultivoMarca) {
        return this._http.post<any>(environment.apiEndpoint + '/CultivoMarca/', cultivoMarca);
    }

    public updateCultivoMarca(cultivoMarca) {
        return this._http.put<any>(environment.apiEndpoint + '/CultivoMarca/', cultivoMarca);
    }

    public deleteCultivoMarca(cultivoId, marcaId) {
        return this._http.delete<any>(environment.apiEndpoint + '/CultivoMarca/?cultivoId=' + cultivoId + '&marcaId=' + marcaId);
    }

    // DENOMINACIONES
    public getDenominacionesByPaisId(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Denominacion/GetAllConFiltro', filters);
    }

    // CAMPAÑAS DENOMINACIÓN
    public getCampanyasByDenominacionId(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Campanya/GetAllConFiltro', filters);
    }

    // ETIQUETADORES DENOMINACIÓN
    public getEtiquetadoresByDenominacionId(filters) {
      return this._http.post<any>(environment.apiEndpoint + '/Etiquetador/GetAllConFiltro', filters);
    }

    // ALMACENES ETIQUETADOR
    public getAlmacenesByEtiquetador(filters) {
      return this._http.post<any>(environment.apiEndpoint + '/Almacen/GetAllConFiltro', filters);
    }

    // OBTENER DESIGNACION
    public getDesignacion(designacionId) {
      return this._http.get<any>(environment.apiEndpoint + '/Designacion/GetById/?designacionId=' + designacionId);
    }

    // CREAR DESIGNACION
    public createDesignacion(designacion) {
      return this._http.post<any>(environment.apiEndpoint + '/Designacion/', designacion);
    }

    // ELIMINAR DESIGNACION
    public deleteDesignacion(designacionId) {
      return this._http.delete<any>(environment.apiEndpoint + '/Designacion/?id=' + designacionId);
    }

    // CULTIVOS - PRODUCTOR - LICENCIA
    public getProductoresByCultivoId(cultivoId) {
        return this._http.post<any>(environment.apiEndpoint + '/Cultivo/GetAllCultivoProductor/?cultivoId=' + cultivoId, null);
    }

    public getProductores(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Productor/GetAllConFiltro', filters);
    }

    public getCultivoProductor(cultivoId, productorId) {
        return this._http.get<any>(environment.apiEndpoint + '/Cultivo/GetCultivoProductorById/?cultivoId=' + cultivoId + '&productorId=' + productorId);
    }

    public createCultivoProductor(cultivoProductor) {
        return this._http.post<any>(environment.apiEndpoint + '/Cultivo/InsertCultivoProductor/', cultivoProductor);
    }

    public updateCultivoProductor(cultivoProductor) {
        return this._http.put<any>(environment.apiEndpoint + '/Cultivo/UpdateCultivoProductor/', cultivoProductor);
    }

    public deleteCultivoProductor(cultivoId, productorId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Cultivo/DeleteCultivoProductor/?cultivoId=' + cultivoId + '&productorId=' + productorId);
    }

    public getLicenciasByProductorCultivoId(cultivoId, productorId) {
        return this._http.post<any>(environment.apiEndpoint + '/Cultivo/GetAllCultivoProductorLicencia/?cultivoId=' + cultivoId + '&productorId=' + productorId, null);
    }

    public createLicencia(licencia) {
        return this._http.post<any>(environment.apiEndpoint + '/Cultivo/InsertCultivoProductorLicencia', licencia);
    }

    public deleteLicencia(cultivoProductorLicenciaId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Cultivo/DeleteCultivoProductorLicencia/?cultivoProductorLicenciaId=' + cultivoProductorLicenciaId);
    }

    // CULTIVOS - PARCELA
    public getParcelasByCultivoId(cultivoId) {
        return this._http.get<any>(environment.apiEndpoint + '/Parcela/GetAllByCultivoId/?cultivoId=' + cultivoId);
    }

    public createCultivoParcela(cultivoParcela) {
        return this._http.post<any>(environment.apiEndpoint + '/Parcela/', cultivoParcela);
    }

    public updateCultivoParcela(cultivoParcela) {
        return this._http.put<any>(environment.apiEndpoint + '/Parcela/', cultivoParcela);
    }

    public deleteCultivoParcela(cultivoId, parcelaId?) {
        return this._http.delete<any>(environment.apiEndpoint + '/Parcela/RemoveCultivoParcela/?cultivoId=' + cultivoId + (parcelaId ? `&parcelaId=${parcelaId}` : ''));
    }

    public deleteCultivoParcelaByFincaId(fincaId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Parcela/RemoveCultivoParcelaByFincaId/?fincaId=' + fincaId);
    }

    // CULTIVOS - CATASTRO
    public getCatastrosByCultivoId(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Catastro/GetAllConFiltro', filters);
    }

    public createCultivoCatastro(cultivoCatastro) {
        return this._http.post<any>(environment.apiEndpoint + '/Catastro/', cultivoCatastro);
    }

    public updateCultivoCatastro(cultivoCatastro) {
        return this._http.put<any>(environment.apiEndpoint + '/Catastro/', cultivoCatastro);
    }

    public deleteCultivoCatastro(catastroId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Catastro/?catastroId=' + catastroId);
    }

    // CAMPANYAS
    public getCampanyas(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Campanya/GetAllConFiltro', filters);
    }

    // PRODUCTORES
    public getProductor(id) {
        return this._http.get<any>(environment.apiEndpoint + '/Productor/GetById/?productorId=' + id);
    }

    public createMunicipioProductor(productor) {
        return this._http.post<any>(environment.apiEndpoint + '/Productor/AddProductorMunicipio', productor);
    }

    public deleteMunicipioProductor(productorId, municipioId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Productor/DeleteProductorMunicipio?productorId='
            + productorId + '&municipioId=' + municipioId);
    }

    public createProductor(productor) {
        return this._http.post<any>(environment.apiEndpoint + '/ApplicationUser/InsertUsuario', productor);
    }

    public updateProductor(productor) {
        return this._http.put<any>(environment.apiEndpoint + '/Productor/', productor);
    }

    public deleteProductor(productorId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Productor/?id=' + productorId);
    }

    public getMunicipiosProductor(productor) {
        return this._http.post<any>(environment.apiEndpoint + '/Municipio/GetAllByProductorId', productor);
    }

    public createProductorPaisDenominacion(productorPaisDenominacion) {
        return this._http.post<any>(environment.apiEndpoint + '/Productor/InsertProductorPaisDenominacion', productorPaisDenominacion);
    }

    public deleteProductorPaisDenominacion(productorId, paisId, denominacionId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Productor/DeleteProductorPaisDenominacion/?productorId=' + productorId + '&paisId=' + paisId +
                                        '&denominacionId=' + denominacionId)
    }

    public getDenominacionesProductor(productorId) {
        return this._http.get<any>(environment.apiEndpoint + '/Productor/GetAllProductorPaisDenominacion/?productorId=' + productorId);
    }

    public getDenominaciones(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Denominacion/GetAllConFiltro', filters);
    }

    public getMunicipiosPais(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Municipio/GetAllConFiltro', filters);
    }

    // IDIOMAS
    public getIdiomas() {
        return this._http.get<any>(environment.apiEndpoint + '/Idioma/GetAll');
    }

    // CULTIVOS
    public getHuertosProductor(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Cultivo/GetAllConFiltro', filters);
    }

    // INFORMES
    public getCultivosReport(filters) {
      return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepCultivos', filters);
    }

    // CSV REPORTES CULTIVOS
    public getCsvCultivosReport(filters) {
      return this._http.post<any>(environment.apiEndpoint + '/Report/ExportCsvCultivos', filters);
    }

    public getProductoresReport(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepProductores', filters);
    }

    public getProductoresCsvReport(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/ExportCsvProductores', filters);
    }

    // AYUDA 
    public getDocHelp(nombreArchivo: string) {
        return this._http.get<any>(environment.apiEndpoint + '/Utilities/GetDocHelp/?nombreArchivo=' + nombreArchivo);
    }
}
